<template>
  <div v-if="component" class="text-sm hover:bg-blue-200 px-3 py-2 space-y-4">
    <component :is="component" :notification="notification" />
    <div class="space-x-2">
      <button
        v-if="isUnread"
        @click="markAsRead"
        class="text-xs leading-4 hover:underline text-blue-600 focus:outline-none"
      >
        Mark as Read
      </button>
      <button
        v-else
        @click="markAsUnread"
        class="text-xs leading-4 hover:underline text-blue-600 focus:outline-none"
      >
        Mark as Unread
      </button>
      <button
        @click="destroy"
        class="text-xs leading-4 hover:underline text-blue-600 focus:outline-none"
      >
        Delete
      </button>
    </div>
  </div>
  <div v-else>Unknown notification type</div>
</template>

<script>
import ProjectTaskCommentCreatedNotification from './notificationListItem/ProjectTaskCommentCreatedNotification.vue';
import ProjectAssetCreatedNotification from './notificationListItem/ProjectAssetCreatedNotification.vue';
import ProjectTaskStatusChangedNotification from './notificationListItem/ProjectTaskStatusChangedNotification.vue';
import ProjectTaskAssignedNotification from './notificationListItem/ProjectTaskAssignedNotification.vue';
import ConversationMessageCreatedNotification from './notificationListItem/ConversationMessageCreatedNotification.vue';
import ProjectConversationMessageCreatedNotification from './notificationListItem/ProjectConversationMessageCreatedNotification.vue';
import AccountProjectAssetsNotification from './notificationListItem/AccountProjectAssetsNotification.vue';
import AccountProjectAssignedNotification from './notificationListItem/AccountProjectAssignedNotification.vue';
import AccountOrderCreatedNotification from './notificationListItem/AccountOrderCreatedNotification.vue';

const componentByNotificationType = {
  'App\\Notifications\\ProjectTaskCommentCreated': 'ProjectTaskCommentCreatedNotification',
  'App\\Acme\\Conversation\\Notifications\\InboundNexmoSmsCreatedNotification':
    'ConversationMessageCreatedNotification',
  'App\\Acme\\Conversation\\Notifications\\ProjectConversationMessageCreatedNotification':
    'ProjectConversationMessageCreatedNotification',
  'App\\Notifications\\ProjectAssetCreatedNotification': 'ProjectAssetCreatedNotification',
  'App\\Acme\\Task\\Notifications\\ProjectTaskStatusChangedNotification':
    'ProjectTaskStatusChangedNotification',
  'App\\Acme\\Task\\Notifications\\ProjectTaskAssignedNotification':
    'ProjectTaskAssignedNotification',
  'App\\Notifications\\ApprovedProjectAssetApprovalRequestCreated':
    'AccountProjectAssetsNotification',
  'App\\Notifications\\RejectedProjectAssetApprovalRequestCreated':
    'AccountProjectAssetsNotification',
  'App\\Notifications\\ProjectAssetPendingApprovalRequest': 'AccountProjectAssetsNotification',
  'App\\Notifications\\ProjectAssigned': 'AccountProjectAssignedNotification',
  'App\\Notifications\\OrderCreated': 'AccountOrderCreatedNotification',
};

export default {
  name: 'NotificationListItem',
  components: {
    ProjectTaskCommentCreatedNotification,
    ProjectAssetCreatedNotification,
    ConversationMessageCreatedNotification,
    ProjectTaskStatusChangedNotification,
    ProjectTaskAssignedNotification,
    AccountProjectAssetsNotification,
    AccountProjectAssignedNotification,
    AccountOrderCreatedNotification,
    ProjectConversationMessageCreatedNotification,
  },
  props: {
    notification: {
      type: Object,
      required: true,
    },
  },
  computed: {
    component() {
      const component = componentByNotificationType[this.notification.type];

      if (!component) {
        return null;
      }

      return component;
    },
    isUnread() {
      return this.notification.readAt === null;
    },
  },
  methods: {
    markAsRead() {
      return this.$store
        .dispatch({
          type: 'ui/currentUserNotifications/markAsRead',
          body: {
            notificationIds: [this.notification.id],
          },
        })
        .then((response) => {
          this.$emit('click', this.notification.id);
          return Promise.resolve(response);
        });
    },
    markAsUnread() {
      return this.$store
        .dispatch({
          type: 'ui/currentUserNotifications/markAsUnread',
          body: {
            notificationIds: [this.notification.id],
          },
        })
        .then((response) => {
          this.$emit('click', this.notification.id);
          return Promise.resolve(response);
        });
    },
    destroy() {
      return this.$store
        .dispatch({
          type: 'ui/currentUserNotifications/destroy',
          notificationId: this.notification.id,
        })
        .then((response) => Promise.resolve(response));
    },
  },
};
</script>
